import React from 'react';
import { SearchedOpinion } from '../types';
import { X } from 'lucide-react';
import { OpinionDetailCard } from './OpinionDetailCard';

interface OpinionDetailsModalProps {
  opinions: SearchedOpinion[];
  isOpen: boolean;
  onClose: () => void;
}

export const OpinionDetailsModal: React.FC<OpinionDetailsModalProps> = ({ opinions, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div data-component="OpinionDetailsModal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">
            Opinion Details ({opinions.length})
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            title="Close"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4">
          <div className="space-y-4">
            {opinions.map((opinion, index) => (
              <OpinionDetailCard key={opinion.id || index} opinion={opinion} />
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
